import axios from "axios";
import { mediaSlice, callTypes } from "./mediaSlice";
const API_URL = process.env.REACT_APP_API_URL;

const { actions } = mediaSlice;

export const fetchMedia = () => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.list }));

  return axios
    .get(API_URL + "upload/files", { params: { _limit: -1 } })
    .then((response) =>
      dispatch(actions.mediaFetched({ mediaList: response.data }))
    )
    .catch((err) =>
      dispatch(actions.catchError({ error: err, callType: callTypes.list }))
    );
};
